module.exports = __webpack_public_path__ + "static/media/t-2-q-5.27239693.jpg";